import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url-search-params.js";
import { defineComponent as _defineComponent } from 'vue';
import BHeader from '~/components/general/BHeader.vue';
import BFooter from '~/components/general/BFooter.vue';
import BLoader from '~/components/general/BLoader.vue';
import BAuth from '~/components/general/Auth/BAuth.vue';
import BAlert from '~/components/general/BAlert.vue';
import { changeLayoutStyles } from '~/utils/utils';
import { useEventsStore } from '~/store/events';
import { useAppStore } from '~/store/app';
export default /*#__PURE__*/_defineComponent({
  __name: 'default_v2',
  setup: function setup(__props) {
    var appStore = useAppStore();
    var eventsStore = useEventsStore();
    var route = useRoute();
    var _useI18n = useI18n(),
      locale = _useI18n.locale;
    var whitelabel = useWhitelabel();
    var bus = useNuxtEventBus();
    var config = reactive({
      showHeader: true,
      eventDescription: true,
      layoutStyle: null
    });
    var foreColor = ref(null);
    var backColor = ref(null);
    var organizer = ref(null);
    var getLoading = computed(function () {
      return appStore.getLoading;
    });
    var getAuthDialog = computed(function () {
      return appStore.getAuthDialog;
    });
    var getOrganizerId = computed(function () {
      return eventsStore.getOrganizerId;
    });
    var isHomePage = computed(function () {
      var _route$name;
      return route === null || route === void 0 ? void 0 : (_route$name = route.name) === null || _route$name === void 0 ? void 0 : _route$name.includes('index');
    });
    var isMaintenancePage = computed(function () {
      var _route$name2;
      return route === null || route === void 0 ? void 0 : (_route$name2 = route.name) === null || _route$name2 === void 0 ? void 0 : _route$name2.includes('maintenance');
    });
    var isBuyScreen = computed(function () {
      var _route$name3, _route$name4, _route$name5, _route$name6;
      return (route === null || route === void 0 ? void 0 : (_route$name3 = route.name) === null || _route$name3 === void 0 ? void 0 : _route$name3.includes('provider/id')) || (route === null || route === void 0 ? void 0 : (_route$name4 = route.name) === null || _route$name4 === void 0 ? void 0 : _route$name4.includes('provider-id')) || (route === null || route === void 0 ? void 0 : (_route$name5 = route.name) === null || _route$name5 === void 0 ? void 0 : _route$name5.includes('tenant/event/id')) || (route === null || route === void 0 ? void 0 : (_route$name6 = route.name) === null || _route$name6 === void 0 ? void 0 : _route$name6.includes('tenant-event-id'));
    });
    var padding = computed(function () {
      return isBuyScreen.value ? 128 : 20;
    });
    var footerColor = computed(function () {
      var _organizer$value, _organizer$value$bran;
      if (isHomePage.value && !getOrganizerId.value) {
        return whitelabel.lightTheme.backgroundPrimary.base;
      }
      if ((_organizer$value = organizer.value) !== null && _organizer$value !== void 0 && (_organizer$value$bran = _organizer$value.branding) !== null && _organizer$value$bran !== void 0 && _organizer$value$bran.primary && !foreColor.value) {
        return "".concat(organizer.value.branding.primary);
      }
      if (foreColor.value && !isHomePage.value) {
        return "#".concat(foreColor.value);
      }
      return whitelabel.lightTheme.backgroundPrimary.base;
    });
    var layoutStyle = computed(function () {
      if (isHomePage.value && !getOrganizerId.value || isMaintenancePage.value) {
        return null;
      }
      return config.layoutStyle;
    });
    function closeAuthDialog() {
      appStore.setAuthDialog(false);
      appStore.setEnableGuestLogin(false);
      var body = document.body;
      body.setAttribute('style', '');
    }
    function openLogin() {
      appStore.setAuthDialog(true);
      var body = document.body;
      body.setAttribute('style', 'height: 100vh; overflow-y: hidden');
    }
    function applyOrganizerColors(fetchedOrganizer) {
      var _organizer$value2;
      organizer.value = fetchedOrganizer;
      var branding = (_organizer$value2 = organizer.value) === null || _organizer$value2 === void 0 ? void 0 : _organizer$value2.branding;
      if (branding) {
        var _foreColor$value, _backColor$value;
        // make sure that widget styles are always applied
        var primary = (_foreColor$value = foreColor.value) !== null && _foreColor$value !== void 0 ? _foreColor$value : branding === null || branding === void 0 ? void 0 : branding.primary;
        var gray = (_backColor$value = backColor.value) !== null && _backColor$value !== void 0 ? _backColor$value : branding === null || branding === void 0 ? void 0 : branding.gray;
        config.layoutStyle = changeLayoutStyles(primary, gray, branding === null || branding === void 0 ? void 0 : branding.highlightSuccess, branding === null || branding === void 0 ? void 0 : branding.highlightInfo, branding === null || branding === void 0 ? void 0 : branding.highlightWarning, branding === null || branding === void 0 ? void 0 : branding.highlightError);
      }
    }

    // Composition-API equivalent of the old created() hook — this runs even
    // before setup()'s own data()-equivalent state is processed, so the listener
    // is attached before organizerFetched could possibly be emitted.
    bus.$on('organizerFetched', applyOrganizerColors);
    useNuxt2Meta(function () {
      return {
        // This sets the lang attribute on the html tag
        // This, in turn, allows the cookie consent component to pick up the correct language
        htmlAttrs: {
          lang: locale.value
        }
      };
    });
    onMounted(function () {
      if (isMaintenancePage.value) {
        // In the case that somewhere loading is set to true and not handled, we fallback to setting it to false always for the maintenance page
        appStore.setLoading(false);
      }
      var urlParams = new URLSearchParams(window.location.search);
      var header = urlParams.get('header');
      if (header === 'false') {
        config.showHeader = false;
      }
      var description = urlParams.get('description');
      if (description === 'false') {
        config.eventDescription = false;
      }
      foreColor.value = urlParams.get('foreColor');
      backColor.value = urlParams.get('backColor');
      var referralCode = urlParams.get('referral_code');
      if (referralCode) {
        sessionStorage.setItem('referralCode', referralCode);
      }
      var showLogin = urlParams.get('show_login');
      if (showLogin) {
        openLogin();
      }
      config.layoutStyle = changeLayoutStyles(foreColor.value, backColor.value);
    });
    onBeforeUnmount(function () {
      bus.$off('organizerFetched');
    });
    return {
      __sfc: true,
      appStore: appStore,
      eventsStore: eventsStore,
      route: route,
      locale: locale,
      whitelabel: whitelabel,
      bus: bus,
      config: config,
      foreColor: foreColor,
      backColor: backColor,
      organizer: organizer,
      getLoading: getLoading,
      getAuthDialog: getAuthDialog,
      getOrganizerId: getOrganizerId,
      isHomePage: isHomePage,
      isMaintenancePage: isMaintenancePage,
      isBuyScreen: isBuyScreen,
      padding: padding,
      footerColor: footerColor,
      layoutStyle: layoutStyle,
      closeAuthDialog: closeAuthDialog,
      openLogin: openLogin,
      applyOrganizerColors: applyOrganizerColors,
      BHeader: BHeader,
      BFooter: BFooter,
      BLoader: BLoader,
      BAuth: BAuth,
      BAlert: BAlert
    };
  }
});